import React from "react";
import MultiSearchInput from "../../multiSearchInput";

type GetDisplayValue = (value: any) => string;

type Props = {
	input;
	meta;
	valueProperty?: string;
	getDisplayValue?: undefined | GetDisplayValue;
	rest?;
	placeholder?: string;
};

export default function CityAndClubSelect({
	input: { onChange, value, name },
	meta,
	valueProperty = "value",
	getDisplayValue = undefined,
	placeholder = "",
}: Props) {
	return (
		<MultiSearchInput
			onChange={onChange}
			value={value}
			valueProperty={valueProperty}
			getDisplayValue={getDisplayValue}
			placeholder={placeholder}
			types={["club", "place"]}
		/>
	);
}
